import React, { useState, useRef, useEffect } from 'react'
import {
  Grid, LinearProgress, MenuItem, DialogTitle, DialogContent, DialogActions, Button, Dialog,
  FormControl, Select, Box, Typography, FormControlLabel, Checkbox, Stack, TextField, Divider, createFilterOptions, Autocomplete,
} from '@mui/material'
import stylesheet from '../detail-container.stylesheet'
import { ClassNameMap, withStyles } from '@mui/styles'
import Draggable from "react-draggable"
import DialogTitleHeaderComponent from '../common/dialog-title-header.component'
import { useSelector } from 'react-redux'
import { RootState, useAppThunkDispatch } from '../../../../redux/store'
import { PatientService } from '../../../../services/patient.service'
import Helper from '../../../../utils/helper'
import { toast } from 'react-toastify'
import { useUpdateDataAction } from '../../../../utils/update-details-hook'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import { updatePatientDetail } from '../../../../redux/patient-detail-slice'
import { isControlVisible } from '../comp-config'

interface IProps {
  open: boolean,
  input: any,
  handleDialogClose: any,
  classes: ClassNameMap
}

const UpdatePatientInfoComponent: React.FC<IProps> = ({ open, input, handleDialogClose, classes }) => {
  const patientInfoRef = useRef(null) as any
  const [isLoading, setIsLoading] = useState(false)
  const [providers, setProviders] = useState('') as any
  const [refList, setRefList] = useState([]) as any
  const [registryStatus, setRegistryStatus] = useState([]) as any

  const patientDetail = useSelector((state: RootState) => state.patientDetail.patientDetail)
  const uiResource = useSelector((state: RootState) => state.metaData.metadata)

  const patientService = new PatientService()
  const [clinicVisit, setClinicVisit] = useState({ note: '', status: 'pending' }) as any
  const [visitDate, setvisitDate] = useState({ date: '', errMsg: '' }) as any
  const [referralData, setReferralData] = useState({
    confirmed_ca_diagnosis: patientDetail.confirmed_ca_diagnosis || '',
    referral_pathway: patientDetail?.referral_pathway || '',
    registry_status: patientDetail?.registry_status || '',
  }) as any
  const [clinicalData, setClinicalData] = useState(patientDetail?.clinical_team || {}) as any
  const dispatch = useAppThunkDispatch()


  const prefix = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr']

  const getLatestNote = (data: any) => {
    const values = Object.values(data) as any
    const lastObject = values[values.length - 1];
    return lastObject?.text;
  };

  useEffect(() => {
    if (input.type === 'Referral') {
      setReferralData({
        confirmed_ca_diagnosis: patientDetail.confirmed_ca_diagnosis || '',
        referral_pathway: patientDetail?.referral_pathway || '',
        registry_status: patientDetail?.registry_status || '',
      })
    }
  }, [patientDetail])

  useEffect(() => {
    if (input.type === 'Clinic visit') {
      if (patientDetail?.clinic_visit_logs?.length > 0) {
        let currobj = (patientDetail?.clinic_visit_logs?.length > 0) ? patientDetail?.clinic_visit_logs.at(-1) : {} as any
        setClinicVisit({
          id: currobj.id,
          note: getLatestNote(currobj?.notes),
          status: currobj.status || 'pending'
        })
        setvisitDate({
          date: (currobj?.visit_date) ? moment.unix(currobj?.visit_date).format('YYYY-MM-DD') : '',
          errMsg: ''
        })
      }
    } else {
      getProviderLists()
      if (input.type === 'Referral') {
        getReferralList()
        setRegistryStatus(uiResource?.REGISTRY_STATUS || [])
      }
    }
  }, [])

  const getReferralList = () => {
    const baseList = ['External Clinician to Specialist', 'External Clinician to RN', 'External Patient Call', 'External Patient via Website', ' ',
      'NM Clinician to Specialist', 'NM Clinician to RN', 'NM Patient Call', 'Epic Order Set', 'NM Patient via Website']
    setRefList(Helper.isAIDA()
      ? baseList
      : [...baseList, ' ', 'AI Echo Model', 'AI ECG Model']
    )
  }

  const validateDate = (d: any, name: any) => {
    const currDate = d ? moment(d).format('YYYY-MM-DD') : ''
    let errorMessage = (currDate === 'Invalid date') ? 'Please select valid date' : ''
    setvisitDate({ date: currDate, errMsg: errorMessage })
  }

  const getProviderLists = () => {
    input?.patientId && patientService.getProviders(input?.patientId).then((res: any) => {
      setIsLoading(false)
      if (res?.data) {
        const providerObj = Object.values(res.data)
          ?.map((item: any) => item ? `${item.first_name} ${item.last_name}` : '')
          ?.filter((name, index, array) => array.indexOf(name) === index)
          ?.sort() || []
        setProviders(providerObj)
      }
      setIsLoading(false)
    }).catch((error: any) => {
      setIsLoading(false)
      toast.error(Helper.getError(error), Helper.bottom_center())
    })
  }

  const getClinicalData = () => {
    let payload = {} as any
    Object.keys(clinicalData).map((key: any) => {
      if (clinicalData[key]?.name && clinicalData[key].name.trim() !== '') {
        payload = {
          ...payload, [key]: {
            ...clinicalData[key],
            prefix: !clinicalData[key]['prefix'] ? 'Dr' : clinicalData[key]['prefix'],
            suffix: !clinicalData[key]['suffix'] ? 'MD' : clinicalData[key]['suffix']
          }
        }
      }
    })
    return payload
  }

  const closeDialog = () => {
    setIsLoading(false)
    handleDialogClose();
  }

  const handleSubmit = () => {
    let payload = getClinicalData()
    setIsLoading(true)
    if (input.type === 'Clinic visit') {
      let payload = {} as any
      if (clinicVisit?.status)
        payload = { ...payload, status: clinicVisit?.status }
      if (clinicVisit?.note !== '')
        payload = { ...payload, note: clinicVisit?.note }

      const vDate = visitDate?.date ? moment(visitDate?.date, 'YYYY/MM/DD').unix() : ''

      if (clinicVisit?.id) {
        payload = { ...payload, visit_date: vDate }
        clinicVisit?.id && patientService.putClinicVisit(input?.patientId, clinicVisit.id, payload).then((res: any) => {
          if (res?.data?.clinic_visit_log)
            dispatch(updatePatientDetail({ clinic_visit_logs: [res.data.clinic_visit_log] }));

          closeDialog()
        }).catch((error) => {
          closeDialog()
          toast.error(Helper.getErrorText(error), Helper.bottom_center())
        })
      } else {
        if (vDate)
          payload = { ...payload, visit_date: vDate }
        input?.patientId && patientService.postClinicVisit(input?.patientId, payload)
          .then((res: any) => {
            if (res?.data?.clinic_visit_log)
              dispatch(updatePatientDetail({ clinic_visit_logs: [res.data.clinic_visit_log] }));
            closeDialog()
          }).catch((error) => {
            closeDialog()
            toast.error(Helper.getErrorText(error), Helper.bottom_center())
          })
      }
      return
    }
    if (input.type === 'Referral' && Object.keys(referralData)?.length > 0) {
      if (referralData.registry_status === '')
        delete referralData.registry_status
      patientService.putPatientProfileDetails(input?.patientId, referralData).then((res: any) => {
        if (res?.data) {
          dispatch(updatePatientDetail({
            confirmed_ca_diagnosis: res.data.confirmed_ca_diagnosis,
            referral_pathway: res.data.referral_pathway,
            registry_status: res.data.registry_status,
            clinical_team: {
              ...patientDetail.clinical_team,
              referring_provider: res.data.referring_provider
            }
          }));

          //   updatePatientData({ isMeasurement: true, isTreatments: true, isConditions: true, isProfileChange: true })
          closeDialog()
        }
      }).catch((error) => {
        closeDialog()
        toast.error(Helper.getErrorText(error), Helper.bottom_center())
      })
    }

    if (Object.keys(payload)?.length > 0 && input?.patientId) {
      patientService.putClinicalDetails(input?.patientId, payload).then((res: any) => {
        if (res?.data)
          dispatch(updatePatientDetail({ clinical_team: res.data }));
        closeDialog()
      }).catch((error: any) => {
        closeDialog()
        toast.error(Helper.getError(error), Helper.bottom_center())
      })
    }
    else
      setIsLoading(false)
  }

  const isDisabled = () => {
    const hasClinicalData = Object.keys(getClinicalData()).length > 0
    const hasReferralData = Object.keys(referralData).length > 0
    return isLoading ||
      (input.type === 'Clinic visit' && visitDate?.errMsg) ||
      (input.type === 'Clinical team' && !hasClinicalData) ||
      (input.type === 'Referral' && !hasClinicalData && !hasReferralData)
  }

  const renderReferral = () => {
    return <Grid container alignItems="baseline" spacing={1.2} className={classes.fullWidth}>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox size="small"
              sx={{ padding: '0rem 0rem 0rem 0.5rem !important', transform: "scale(0.6)", }}
              name='confirmed_ca_diagnosis'
              checked={(referralData.confirmed_ca_diagnosis)}
              onChange={(e: any) => setReferralData({ ...referralData, confirmed_ca_diagnosis: (e.target.checked) })}
            />
          }
          label={<Typography pl={0} className={classes.toxicityEvalBoxVal}>Confirmed CA diagnosis</Typography>}
        />
      </Grid>
      <Grid item xs={12}>
        <Stack direction='row' spacing={2} alignItems='center'>
          <Box>
            <Typography variant="body2" color="textSecondary" className={classes.desc}>Referral pathway</Typography>
            <FormControl className={classes.formControlStage}>
              <Select
                id="Referral"
                labelId="Referral-pathway-label"
                variant="standard"
                onChange={(e) => setReferralData({
                  ...referralData,
                  referral_pathway: e.target.value
                })}
                value={referralData?.referral_pathway || ''}
                sx={{ width: '9rem !important' }}
                inputProps={{ classes: { icon: classes.icon, } }}
              >
                {refList && refList
                  //?.sort((a: any, b: any) => a.toLowerCase() > b.toLowerCase() ? 1 : -1)
                  ?.map((i: any) =>
                    <MenuItem key={i} value={i} className={classes.programMenu}>{i} </MenuItem>
                  )}
              </Select>
            </FormControl>
          </Box>
          <Box>
            <Typography variant="body2" color="textSecondary" className={classes.desc}>Registry status</Typography>
            <FormControl className={classes.formControlStage}>
              <Select
                id="Registry-status"
                labelId="Registry-status-label"
                variant="standard"
                onChange={(e) => setReferralData({
                  ...referralData,
                  registry_status: e.target.value
                })}
                value={referralData?.registry_status || ''}
                sx={{ width: '9rem !important' }}
                inputProps={{ classes: { icon: classes.icon, } }}
              >
                {registryStatus && Object.keys(registryStatus).length > 0 &&
                  Object.keys(registryStatus)
                    ?.map((i: any) =>
                      <MenuItem key={i} value={registryStatus?.[i]} className={classes.programMenu}>{registryStatus?.[i]}</MenuItem>
                    )}
              </Select>
            </FormControl>
          </Box>
        </Stack>
      </Grid>
      {/* Referring is a flag on a care team membership (is_referring), not a field here.
          Its Autocomplete saved free text rather than a registry selection, so the name
          it stored was not guaranteed to be a real provider (RD 2026-08-08). */}
      {isControlVisible('referring_free_text') && (
        <Grid item xs={12}>
          <Box pt={1}>{renderPatientInfo('Referring', 'referring_provider')}</Box>
        </Grid>
      )}
    </Grid>
  }

  const renderPatientInfo = (title: string, type: string) => {
    const handleClinicalChange = (e: any) => {
      let name = ''
      let value = ''

      if (typeof e === 'string' && e) {
        name = 'name'
        value = e
      } else if (e) {
        name = e.target.name
        value = e.target.value
      }
      if (name !== '')
        setClinicalData((prev: any) => ({
          ...prev, [type]: { ...(prev?.[type] || {}), [name]: value }
        }))
    }

    return <Stack direction='row' className={classes.fullWidth} mb={0}>
      <Box width={input.type === 'Referral' ? '100%' : '90%'}>
        <Typography variant='subtitle2' className={classes.subHeader} mb={0.4}>{title}</Typography>
        <Divider />
        <Stack width={'100%'} direction={'row'} pt={1.8} spacing={3} justifyContent={'flex-start'} alignItems={'baseline'}>
          <Box>
            <Typography variant="body2" color="textSecondary" className={classes.desc}>Name prefix</Typography>
            <Select
              sx={{ width: '5rem !important', padding: '0px !important' }}
              variant="standard"
              tabIndex={-1}
              displayEmpty
              name="prefix"
              className={classes.cardLabNotes}
              inputProps={{ 'aria-label': 'prefix', tabIndex: -1 }}
              value={(clinicalData?.[type]?.['prefix']) || 'Dr'}
              onChange={handleClinicalChange}
            >
              {prefix.map((r) => (
                <MenuItem className={`${classes.programMenu}`} value={r}>{r}</MenuItem>
              ))}
            </Select>
          </Box>
          <Box alignItems={"baseline"}>
            <Typography variant="body2" color="textSecondary" className={classes.desc}>Name</Typography>
            <Autocomplete
              id="add-name"
              options={providers}
              filterOptions={createFilterOptions({ matchFrom: 'any', stringify: (option: any) => option })}
              value={clinicalData?.[type]
                ? clinicalData?.[type]?.['name']
                  ? clinicalData?.[type]?.['name']
                  : clinicalData?.[type]
                    ? `${clinicalData?.[type]?.['first_name'] || ''} ${clinicalData?.[type]?.['last_name'] || ''}`
                    : ''
                : ''
              }
              onInputChange={(event, newInputValue) => handleClinicalChange(newInputValue.trim())}
              disableClearable
              sx={{
                width: '10rem',
                padding: '0.195rem 0rem 0rem 0rem!important',
                '& .MuiAutocomplete-noOptions ': {
                  fontSize: '0.75rem !important'
                },
              }}
              ListboxProps={{ sx: { '& .MuiAutocomplete-option': { padding: '2px 0px 2px 8px !important' } } }}
              renderInput={(params: any) => <TextField
                {...params}
                variant="standard"
                size="small"
                InputProps={{ ...params.InputProps }}
              />
              }
            />
          </Box>
          <Box>
            <Typography variant="body2" color="textSecondary" className={classes.desc}>Qualification summary</Typography>
            <TextField
              variant="standard"
              tabIndex={-1}
              placeholder='MD'
              name="suffix"
              size="small"
              sx={{ padding: '0.21rem 0rem 0rem 0rem !important' }}
              inputProps={{ 'aria-label': 'suffix', tabIndex: -1, style: { fontSize: '0.7rem' } }}
              InputLabelProps={{ style: { fontSize: '0.7rem' } }}
              className={classes.fullWidth}
              rows="1"
              value={(clinicalData?.[type]?.['suffix']) || 'MD'}
              onChange={handleClinicalChange}
            />
          </Box>
        </Stack>
      </Box>
    </Stack>
  }

  const renderClinicalDetails = () => {
    return <Stack spacing={1}>
      {renderPatientInfo('Amyloid cardiologist', 'amyloid_cardiologist')}
      {renderPatientInfo('Cardiologist', 'cardiologist')}
      {renderPatientInfo('Hematologist', 'hematologist')}
      {renderPatientInfo('Neurologist', 'neurologist')}
    </Stack>
  }

  const renderClinicVisit = () => {
    const statusList = ['completed', 'pending'] as any
    return <Stack spacing={1.5}>
      <Box>
        <Typography variant="body2" color="textSecondary" className={classes.desc}>Status</Typography>
        <FormControl className={classes.formControlStage}>
          <Select
            id="test-type"
            labelId="add-test-label"
            variant="standard"
            value={clinicVisit?.status || ''}
            onChange={(e: any) => setClinicVisit({ ...clinicVisit, status: e.target.value })}
            sx={{ width: '5rem !important' }}
            inputProps={{ classes: { icon: classes.icon, } }}
          >
            {statusList && statusList?.map((i: any) =>
              <MenuItem key={i} value={i} className={classes.programMenu}>
                {i !== '' ? Helper.toCamelCase(i) : i}
              </MenuItem>
            )}
          </Select>
        </FormControl>
      </Box>
      <Box>
        <TextField
          id="outlined-basic"
          name="test_notes"
          variant="outlined"
          placeholder="Add note here"
          size="small"
          value={clinicVisit?.note || ''}
          inputProps={{ style: { fontSize: '0.7rem' } }}
          InputLabelProps={{ style: { fontSize: '0.7rem' } }}
          multiline={true}
          rows="2"
          onChange={(e: any) => setClinicVisit({ ...clinicVisit, note: e.target.value })}
          sx={{
            width: '23.5rem !important',
            '& .MuiOutlinedInput-root': { padding: '0.2rem 0rem 0.2rem 0.5rem !important' }
          }}
        />
      </Box>
      <Box>
        <Typography pb={0.2} variant="body2" color="textSecondary" className={classes.desc}>{'Visit date'}</Typography>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            className={classes.taskSchedule}
            name={'date'}
            format={'MM/DD/YYYY'}
            formatDensity="dense"
            slotProps={{
              textField: { size: 'small', error: false },
              actionBar: { actions: ['clear'] },
            }}
            value={moment(moment(visitDate.date, 'YYYY-MM-DD'), 'MM/DD/YYYY')}
            onChange={(e: any) => validateDate(e, 'collectionDate')}
          />
        </LocalizationProvider>
        {visitDate?.errMsg !== '' && <Typography color={'red'} className={classes.desc}>{visitDate?.errMsg}</Typography>}
      </Box>
    </Stack>
  }

  return (
    <Draggable ref={patientInfoRef} defaultPosition={{ x: 0, y: 0 }} handle='.patient-info-dialog'>
      <Dialog
        id={'patient-info'}
        fullWidth={true}
        maxWidth="sm"
        open={open}
        onClose={handleDialogClose}
        aria-labelledby="patient-info"
        hideBackdrop
        disableScrollLock
        onKeyUp={(e) => {
          e.preventDefault();
          if (e.key === 'Enter' && !isDisabled())
            handleSubmit()
        }}
        sx={{ position: "absolute", left: '15%', }}
      >
        <DialogTitle className={classes.addPatientQuestionHeaderSection} classes={{ root: 'patient-info-dialog' }}>
          <DialogTitleHeaderComponent title={input.title} handleDialogClose={handleDialogClose} />
        </DialogTitle>
        <Box> {isLoading && <LinearProgress />} </Box>

        <DialogContent className={classes.addPatientDialogContent} sx={{ padding: '1rem 0.5rem 1.5rem 1.8rem' }}>
          {input.type === 'Referral'
            ? renderReferral()
            : input.type === 'Clinic visit'
              ? renderClinicVisit()
              : renderClinicalDetails()
          }
        </DialogContent>

        <DialogActions>
          <Grid container spacing={2} className={classes.containerPadding} justifyContent="flex-end">
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                disabled={isDisabled()}
                onClick={handleSubmit}
                component="label"
              >
                Submit
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                onClick={handleDialogClose}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </Draggable>
  );
};

export default withStyles(stylesheet)(UpdatePatientInfoComponent)
